import { DeliveryTimeOffer } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/types'
import dayjs from 'dayjs'

export const getAvailableDays = (offer: DeliveryTimeOffer): string[] => {
    const days = new Set<string>()

    if (offer.asap) {
        const day = dayjs().startOf('day')

        days.add(day.toISOString())
    }

    if (offer.timed) {
        offer.timed.options.forEach((option) => {
            const day = dayjs(option.start).startOf('day').toISOString()

            if (!days.has(day)) days.add(day)
        })
    }

    return [...days]
}
